export default __webpack_public_path__ + "static/media/116-5861-023_3000.4838df7b.png";